import keymirror from 'keymirror';

export default keymirror({
  GET_ADDITIONAL_DATA: null,
  GET_ADDITIONAL_DATA_SUCCESS: null,
  COMMIT_PROGRESS: null
});
